import React from 'react';

const CreditRangeFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.3334 8.83333V4.83333C16.3334 4.09695 15.7364 3.5 15 3.5H3.00002C2.26364 3.5 1.66669 4.09695 1.66669 4.83333V12.8333C1.66669 13.5697 2.26364 14.1667 3.00002 14.1667H10.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.66669 7.5H16.3334" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.3333 13.5H18.6666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 16H18.3333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.3334 12L16.6667 17.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.6667 12L14 17.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CreditRangeFilterIcon;
